<template lang="pug">
button(
  type="button",
  class="flex flex-col items-center justify-center gap-1 md:gap-3 py-8 px-2 rounded-xl border border-[#707070] aspect-[120/132] md:aspect-[198/172] w-full max-w-[120px] md:max-w-[198px] h-full text-[#7E7E7E] txt__notoSB16 hover:bg-gray-50",
  :class="{ 'bg-[#F97066]/10 border-[#F97066] text-[#F97066]': active }"
  :disabled="disabled"
  @click.prevent="emit('clickReaction', props.type)"
)
  span(class="material-symbols-outlined text-[#AFAFAF] !text-5xl md:!text-6xl") {{ icon }}
  div
    p {{ label }}
    p ({{ count ?? 0 }})
</template>

<script setup lang="ts">
import {} from 'vue';
// types
import type { ReactionType } from '@/ts/public/type/ReactionType';
const props = defineProps<{
  type: ReactionType['type'];
  icon: string;
  label: string;
  count: number;
  active: boolean;
  disabled: boolean;
}>();


const emit = defineEmits<{
  (e: 'clickReaction', type: ReactionType['type']): void
}>()


</script>

<style lang="sass" scoped>

</style>